import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  loadingStyle: {
    minHeight: "100vh",
    display: "grid",
    placeContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "99999",
    width: "100vw",
    height: "100vh",
    backgroundColor: "#aeaeae6b",
  },
  unloadingStyle: {
    width: "0",
    zIndex: "99999"
  },
});

export default styles;
